import { render, staticRenderFns } from "./FormCreditiImposta.vue?vue&type=template&id=2350b01a&"
import script from "./FormCreditiImposta.vue?vue&type=script&lang=js&"
export * from "./FormCreditiImposta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports